module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.filtered.length) ? _c('div', {
    staticClass: "rss"
  }, [_c('h2', {
    staticClass: "pointer shadow-text",
    class: {
      'collapsed': _vm.collapsed
    }
  }, [_c('a', {
    attrs: {
      "href": _vm.destinationUrl
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.title)
    }
  })]), (_vm.collapsed) ? _c('span', {
    staticClass: "expando",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v(" …")]) : _c('span', {
    staticClass: "expando",
    on: {
      "click": function($event) {
        _vm.collapsed = !_vm.collapsed
      }
    }
  }, [_vm._v(" ⇐")])]), (_vm.busy) ? _c('icon', {
    attrs: {
      "name": "refresh",
      "scale": "3",
      "spin": "spin"
    }
  }) : _vm._e(), _c('ul', _vm._l((_vm.filtered), function(post) {
    return (!_vm.collapsed && post) ? _c('li', {
      staticClass: "post"
    }, [_c('a', {
      attrs: {
        "href": post.link
      }
    }, [(post) ? _c('span', [_vm._v(_vm._s(_vm.decodeHtml(post.title)))]) : _vm._e()]), (_vm.hide !== 'description') ? _c('p', [(post.pic && post.descriptionLength < 600) ? _c('small', {
      domProps: {
        "innerHTML": _vm._s(post.description)
      }
    }) : _vm._e()]) : _vm._e()]) : _vm._e()
  }))], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41aec611"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RSS.vue
// module id = 1078
// module chunks = 1